import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaTruck, FaArrowCircleLeft, FaShoppingCart } from "react-icons/fa";
import { useState } from "react";
import { Stack } from "@mui/system";
import PopupWithButton from "./PopupWithButton";
import { AiFillCloseCircle } from "react-icons/ai";
import { Slide } from "react-slideshow-image";
import colors from "../config/colors";
import { Margin } from "@mui/icons-material";
import CancelSharpIcon from '@mui/icons-material/CancelSharp';

const carddata = [
  {
    id: 1,
    img: require("../assets/img/box-truck.PNG"),
    avarge: "Average: 2.5 Million Impressions",
    month: "Months",
    permonth: "Pricing(per month)",

    after3: 3,
    price1: "$ 2,985",

    after6: 6,
    price2: "$ 2,750",

    after12: 12,
    price3: "$ 2,575",

    charge: "1 Time Wrapping Charge: $3,085 Per truck",
    type: "BOX TRUCK",
    per:"(Per Truck)"
  },
  {
    id: 2,
    img: require("../assets/img/Car-e.jpeg"),
    avarge: "Average: 250K Impressions",
    month: "Months",
    permonth: "Pricing(per month)",

    after3: 3,
    price1: "$ 1,500",

    after6: 6,
    price2: "$ 1,250",

    after12: 12,
    price3: "$ 1,150",

    charge: "1 Time Wrapping Charge: $515 per car ",
    charge1:" Minimum purchase: 5 cars",
    type: "CARS",
    per:"(Per Car)"
  },
  {    
    id: 3,
    img: require("../assets/img/led-truck-home.PNG"),
    avarge: "Average: 150K Impressions",
    month: "Days",
    permonth: "Pricing(per day)",

    after3: 3,
    price1: "$ 2,985",

    after6: 6,
    price2: "$ 2,750",

    after12: 12,
    price3: "$ 2,575",

    charge: "Extra 100K Impressions for Booking 15+ Days",
    type: "LED TRUCK",
    per:"(Per Truck)"
  },
];

const Menu = [
  {
    id: 1,
    Image: require("../assets/img/cars.PNG"),
    name: "Ride Share CAR",
    impression: "27,00000/mth",

    types: ["Uber", "Lyft", "Gig Economy"],

    type: "vehicle",
    Vehicle_info: {
      avg_imp: "1,000,000/mth",
      dimenstions: ["-Compact", "-Midsize", "-XL Vehicle"],
      sold_by: ["Weekly", "Monthly"],
      fule_type: "Gas, hybrid,electric",
    },
    Vehicle_KPI: {
      best_user: [
        "Swram 10+units",
        "one on one",
        "viewers",
        "electric",
        "cars available",
      ],
      local_drivers: ["Professional brand ambassadors", "trustworthy, etc"],
      routes: ["local", "neighborhoods", "residential areas,", "highways"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },

  {
    id: 2,
    Image: require("../assets/img/box-truck.PNG"),
    name: "Box Truck",
    impression: "2,700,000/mth",
    types: ["Local", "Commercial", "Lastmile"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "2,700,000/mth",
      dimenstions: ["Side- 8x26ft", "Rear- 8x8ft", "Front- 3x7ft"],
      sold_by: ["3 months", "6 months", "12 months"],
      ad_space: "500 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Local market",
        "saturation,",
        "local street presence",
        "special events",
      ],
      local_drivers: ["Professional brand ambassadors", "trustworthy, etc"],
      routes: [
        "Dedicated daily",
        "routes in",
        "neighbordhoods",
        "and pr highways",
      ],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },
  {
    id: 3,
    Image: require("../assets/img/semi-truck-home.PNG"),
    name: "Semi-Truck",
    impression: "2,000,000/mth",
    types: ["Fully", "Customizable", "Routes"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "3,000,000",
      dimenstions: ["Side- 8x53ft", "Rear- 8x8ft"],
      sold_by: ["3 months", "6 months", "12 months"],
      ad_space: "912 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Great for multistate",
        "state campaigns,",
        "reach millions of",
        "eyes on highways",
      ],
      local_drivers: ["Commercial", "professional,", "background", "checked"],
      routes: ["Highways", "freeways, long", "distance driving"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },
  {
    id: 4,
    Image: require("../assets/img/led-truck-home.PNG"),
    name: "Led Truck",
    impression: "2,000,000/mth",
    types: ["Fully", "Customizable", "Routes"],

    type: "veicle",
    Vehicle_info: {
      avg_imp: "250,000/day",
      dimenstions: ["Side-6.5x11.5ft", "Rear- 6x6ft"],
      sold_by: ["8 hours slots", "3 -days", "Weekly"],
      ad_space: "500 sq. ft.",
    },
    Vehicle_KPI: {
      best_user: [
        "Static/video",
        "displays,",
        "competition",
        "targeting, political",
      ],
      local_drivers: ["Ride Share & Gig"],
      routes: ["100% custom", "routes for client,", "no higways"],
    },
    drive_time: {
      hours: "7am to 7pm",
      days: "6 days per week",
      months: "200 hours per mth.",
    },
  },

  {
    id: 5,
    Image: require("../assets/img/phopt-shoot.PNG"),
    name: "Photo/Video",
    type: "other",
    description:
      "Introducing Rolling Adz's photoshoot and video package - the perfect way to showcase your advertisement on our mobile billboards in a visually stunning and professional manner. Our package includes photoshoots and video of your advertisement on our box trucks, LED trucks, semi trucks and wrapped cars. You'll receive high-resolution images and videos, professionally edited and ready to use for your website, social media or other marketing materials.",
  },
  {
    id: 6,
    Image: require("../assets/img/swram.PNG"),
    name: "Swarm",
    type: "other",
    description:
      "Introducing Swarm, the ultimate advertising solution for businesses looking to increase visibility and reach in a specific location. With Swarm, you can send a fleet of advertiser vehicles, including box trucks, LED trucks, and wrapped cars, around a specific location or to and from a specific location. This allows many eyes to be on your advertisement in that specific area and time, maximizing your brand's exposure and impact. Get your message out there with Swarm and Drive more customers to your business today.",
  },
  {
    id: 7,
    Image: require("../assets/img/retargeting-home.PNG"),
    name: "RETARGETING IMPRESSIONS",
    type: "other",
    description:
      "Once a candidate enters the capture radius of a vehicle, their mobile phone's advertising ID is captured by our beacon technology. We can then filter this audience down by over 200 affinity groups (age, gender, income, interests, etc), and serve display ads in-app or in- browser, driving them to your careers page or specific job postings. We can also provide the entire collected audience if you would like to advertise to them through your own channels (sold in 200k impression intervals).",
  },
];

export default () => {
  const [open, setopen] = useState(false);
  const [current, setCurrent] = useState();
  useEffect(() => {
    document.title = "RollingAdz: Agency Packages" || "Default Title";
  }, []);
  return (
    <div>
      <div className="main  pe-sm-4 ps-sm-4" style={{height:"100vh", paddingTop:"2.3rem"}}>
        <div className="request-sec p-1">
          <div className="container " style={{ background: "#D4D4D4" }}>
            <div className="row roll-roz position-relative">
              <div className="col d-flex justify-content-between">
                <div className="" style={{width:"130px"}}>
                <Link to={"/"}>
                  <button className="bg-transparent border-0">
                    <CancelSharpIcon style={{color:"#005E9D",margin:"5px"}} size={100} color={colors.primary} />
                  </button>
                </Link>
                </div>
                <div className="text-center">
                  <h3 className="blue-clr p-3 fs-4">Our Packages!</h3>
                </div>
                <div>
                  <img
                    className="h-100 w-100"
                    src={require("../assets/img/rolling_roz.png")}
                    alt="logo"
                  />
                </div>
              </div>
            </div>

            <div className="row  d-flex m-auto justify-content-between p-sm-2 p-1 pe-3 ">
              {carddata.map((e) => {
                return (
                  <div className=" col-md-6  col-lg-4  d-flex justify-content-center   mb-4">
                    <div
                      class="card "
                      style={{ border: "1px solid #005E9D", width: "87%",borderRadius:"10px" }}
                    >
                      <div
                        className="text-center"
                        style={{
                          backgroundColor: "#005E9D",
                          color: "white",
                          borderTopLeftRadius: "6px",
                          borderTopRightRadius: "6px",
                        }}
                      >
                        <h6
                          className="p-1"
                          style={{ margin: "3px", fontSize: "19px" }}
                        >
                          {e.type}
                        </h6>
                      </div>
                      
                      <div class="card-body d-flex flex-column justify-content-between"  >
                        
                        <div className=" ">
                        <div className="">
                          <img
                            src={e.img}
                            style={{ borderRadius: "13px" }}
                            width={"100%"}
                            height={"auto"}
                            class="card-img-top"
                            alt="..."
                          />
                        </div>
                        <p 
                          className="card-title text-center pt-1"
                          style={{ fontSize: "12px", color: "#005E9D" }}
                        >
                          {e.avarge}
                        </p>
                        <div className="row m-auto d-flex justify-content-center">
                          <div
                            className="col-4 text-center"
                            style={{ borderRight: "3px solid #005E9D" }}
                          >
                            <p
                              class="card-text"
                              style={{
                                borderBottom: "3px solid #005E9D",
                                fontWeight: "50px",
                                paddingBottom: "4px",
                                color: "#005E9D",
                              }}
                            >
                              {e.month}
                            </p>
                            <p
                              className="card-text"
                              style={{ color: "#005E9D" }}
                            >
                              {e.after3}
                            </p>
                            <p
                              className="card-text"
                              style={{ color: "#005E9D" }}
                            >
                              {e.after6}
                            </p>
                            <p
                              className="card-text"
                              style={{ color: "#005E9D" }}
                            >
                              {e.after12}
                            </p>
                          </div>
                          <div className="col-8 text-center">
                            <p
                              class="card-text"
                              style={{
                                borderBottom: "3px solid #005E9D",
                                paddingBottom: "4px",
                                space: "nowrap",
                                color: "#005E9D",
                              }}
                            >
                              {e.permonth}
                            </p>
                           
                            <div className="d-flex justify-content-center d-flex align-items-center pe-1" >
                            <p style={{ color: "#005E9D" }} class="card-text">
                              {e.price1}
                            </p>
                              <p className="ps-2" style={{ fontSize: "12px", color: "#1E71A8",fontWeight:"600" }}>{e.per}</p>
                            </div>
                            <div className="d-flex justify-content-center align-items-center pe-1" >
                            <p style={{ color: "#005E9D" }} class="card-text">
                              {e.price2}
                            </p>
                              <p className="ps-2" style={{ fontSize: "12px", color: "#1E71A8",fontWeight:"600" }}>{e.per}</p>
                            </div>
                            <div className="d-flex justify-content-center d-flex align-items-center pe-1" >
                            <p style={{ color: "#005E9D" }} class="card-text">
                              {e.price3}
                            </p>
                              <p className="ps-2" style={{ fontSize: "12px", color: "#1E71A8",fontWeight:"600" }}>{e.per}</p>
                            </div>
                          </div>
                           <div className="m-auto pt-1 " style={{width:"79%",}}>
                            <p
                            className="card-title text-center p-0 m-0"
                            style={{ fontSize: "12px", color: "#005E9D",fontFamily:"sans-serif",  }}
                            >
                            {e.charge}
                          </p>
                            <p
                            className="card-title text-center "
                            style={{ fontSize: "12px", color: "#005E9D",fontFamily:"sans-serif"  }}
                            >
                            {e.charge1}
                          </p>
                          </div>
                          

                        </div>
                        </div>



                        <div className="text-center d-flex justify-content-center aling-items-center">
                          <Link 
                            to="https://calendly.com/rolling-adz-specailist/meet-a-rolling-adz-brand-strategist"
                            class="btn"
                            style={{
                              backgroundColor: "#005E9D",
                              color: "white",
                              padding: "16px  25px 16px 25px",
                             
                              fontSize: "13px",
                              fontWeight:"bold"
                            
                              
                            }}
                          >
                            GET STARTED
                          </Link>
                        </div>
                      
                    </div>
                  </div></div>
                );
              })}
            </div>
            <div
              className="row mx-auto my-4 mt-1 mb-5"
              style={{
                backgroundColor: "white",
                border: "1px solid #005E9D ",
                borderRadius: "15px",
                width: "94%",
              }}
            >
              <div className="  mb-1 col-lg-4">
                <div
                  className=""
                  style={{
                    backgroundColor: "#005E9D",
                    borderTopLeftRadius: "10px",
                    borderBottomRightRadius: "10px",
                    width:"87%"
                  }}
                >
                  <h5 className="pt-2 pb-2 text-center " style={{ color: "white" }}>
                    DIGITAL RETARGETING
                  </h5>
                </div>
                <div className="text-center mt-3">
                  <p className="card-text"
                    style={{
                      fontSize: "17px",
                      color: "#005E9D",
                      padding: "2px",
                      fontWeight:"500",
                      fontFamily:"sans-serif"
                    }}
                  >
                    Retargeting: $11.00 CPM 
                  </p>
                  <p
                    className="card-text"
                    style={{
                      fontSize: "17px",
                      
                      color: "#005E9D",
                      padding: "2px",
                      fontWeight:"500"
                    }}
                  >
                    (Minimum of 200K Impressions)
                  </p>
                  <div>
                    {" "}
                    <Link
                      className="BTN"
                      to="https://calendly.com/rolling-adz-specailist/meet-a-rolling-adz-brand-strategist"
                      class="btn"
                      style={{
                        marginTop: "20px",
                        backgroundColor: "#005E9D",
                        color: "white",
                        padding: "16px  25px 16px 25px",
                        fontSize: "13px",
                        fontWeight: "bold",
                      }}
                    >
                      GET STARTED
                    </Link>
                  </div>
                </div>
              </div>
              <div className=" col-lg-8 pt-2 " style={{}}>
                <img
                  src={require("../assets/img/img.png")}
                  width={"100%"}
                  height={"100%"}
                  style={{
                    borderRadius: "14px",
                    overflow: "hidden",
                    paddingTop: "12px",
                    paddingBottom: "2px",
                  }}
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {current && (
        <>
          {current.type == "other" ? (
            <EventCard open={open} item={current} setopen={setopen} />
          ) : (
            <NewCard open={open} item={current} setopen={setopen} />
          )}
        </>
      )}
    </div>
  );
};

function NewCard({ open, setopen, item }) {
  function handleSubmit() {}

  return (
    <PopupWithButton
      title=""
      content={
        <div className="">
          <div className="d-flex justify-content-between align-items-center px-2 ">
            <div onClick={() => setopen(false)}>
              <AiFillCloseCircle size={30} color={colors.primary} />
            </div>
            <h3 className="text_color text-decoration-underline">
              Vehicle: {item.name}
            </h3>

            <div style={{ width: "8rem" }}>
              <img
                width={"100%"}
                src={require("../assets/img/rolling_roz.png")}
                alt=""
              />
            </div>
          </div>
          <div className="">
            <Slide>
              <div className="each-slide-effect">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundSize: "cover",
                    height: "250px",
                    backgroundImage: `url(${item.Image})`,
                  }}
                >
                  {/* <span>Slide 1</span> */}
                </div>
              </div>
            </Slide>
          </div>
          {/* <img className="card_img_top img-fluid" src={item.Image} alt="Card image" style={{width: '100%', height: 'auto'}} /> */}
          <div className="box_bg p-3 border border-secondary rounded mt-2">
            <h5 className="text_color text-decoration-underline">
              Vehicle Info:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Avg.Impression:</h6>

                <p className="fs_14px">{item.Vehicle_info.avg_imp}</p>
                {item.Vehicle_info.ad_space && (
                  <div>
                    <h6 className="text-muted">Ad Space</h6>
                    <p className="fs_14px">{item.Vehicle_info.ad_space}</p>
                  </div>
                )}
                {item.Vehicle_info.fule_type && (
                  <div>
                    <h6 className="text-muted">Fuel Type</h6>
                    <p className="fs_14px">{item.Vehicle_info.fule_type}</p>
                  </div>
                )}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Dimensions:</h6>
                {item.Vehicle_info.dimenstions.map((subitem) => (
                  <p className="fs_14px">{subitem}</p>
                ))}
              </div>
              <div className="col-md-4">
                <h6 className="text-muted">Sold By:</h6>{" "}
                {item.Vehicle_info.sold_by.map((subitem) => (
                  <div className="p-1">
                    <input type="checkbox" disabled checked name="" id="" />

                    <label className="fs_14px ps-1" htmlFor="">
                      {subitem}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <h5 className="text_color text-decoration-underline">
              Vehicle KPI's:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Best Uses:</h6>

                {item.Vehicle_KPI.best_user.map((subitem) => (
                  <p className="fs_14px m-0">{subitem}</p>
                ))}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Local Drivers:</h6>

                {item.Vehicle_KPI.local_drivers.map((sub) => (
                  <p className="fs_14px m-0">{sub}</p>
                ))}
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Routes:</h6>
                {item.Vehicle_KPI.routes.map((subitem) => (
                  <p className="fs_14px m-0">{subitem}</p>
                ))}
              </div>
            </div>

            <h5 className="text_color text-decoration-underline">
              Drive Time:
            </h5>
            <div className="row">
              <div className="col-md-4">
                <h6 className="text-muted">Hours:</h6>
                <p>{item.drive_time.hours}</p>
              </div>

              <div className="col-md-4">
                <h6 className="text-muted">Days:</h6>
                <p className="fs_14px">{item.drive_time.days}</p>
              </div>
              <div className="col-md-4">
                <h6 className="text-muted">Months:</h6>
                <p className="fs_14px">{item.drive_time.months}</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-1 mt-2">
            {/* <div>
      <input min={0} type="number" name="" id="" style={{width:"4rem", height:"3rem"}} placeholder="0 Qty"/>
      </div> */}
            <div>
              <button className="btn btn_bg px-4 py-3">
                View Packages
                {/* <FaShoppingCart size={25} style={{paddingLeft:"5px"}}/> */}
              </button>
            </div>
          </div>
        </div>
      }
      isOpen={open}
      // loading={loading}
      yesName=""
      yesClick={handleSubmit}
      cancelName=""
      cancelClick={() => setopen(false)}
    />
  );
}

function EventCard({ open, setopen, item }) {
  console.log(item);
  function handleSubmit() {}

  return (
    <PopupWithButton
      title=""
      content={
        <>
          <div className="d-flex justify-content-between align-items-center px-2">
            <div onClick={() => setopen(false)}>
              <AiFillCloseCircle size={30} color={colors.primary} />
            </div>
            <h3 className="text_color text-decoration-underline">
              {item.name}
            </h3>
            <div style={{ width: "8rem" }}>
              <img
                width={"100%"}
                src={require("../assets/img/rolling_roz.png")}
                alt=""
              />
            </div>
          </div>
          <Stack>
            <Slide>
              <div className="each-slide-effect">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundSize: "cover",
                    height: "250px",
                    backgroundImage: `url(${item.Image})`,
                  }}
                >
                  {/* <span>Slide 1</span> */}
                </div>
              </div>
            </Slide>
          </Stack>
          <div className="box_bg p-3 border border-secondary rounded mt-2">
            <h5 className="text_color text-decoration-underline">
              Product Description:
            </h5>
            <p>{item.description}</p>
          </div>
          <div className="d-flex justify-content-center align-items-center mt-2">
            {/* <div>
        <input min={0} type="number" name="" id="" style={{width:"4rem", height:"3rem"}} placeholder="0 Qty"/>
        </div> */}
            <div>
              <button className="btn btn_bg px-4 py-3">
                View Packages
                {/* <FaShoppingCart size={25} style={{paddingLeft:"5px"}}/> */}
              </button>
            </div>
          </div>
        </>
      }
      isOpen={open}
      // loading={loading}
      yesName=""
      yesClick={handleSubmit}
      cancelName=""
      cancelClick={() => setopen(false)}
    />
  );
}
